import React, { Component } from 'react';

export class Label extends Component {
    titleRef = null;
    constructor(props) {
        super(props);
        this.state = {
            title: 'Task Id',
            editTitle: false,
            name: 'Label',
            value: '',
            isActive: false,
            displaytype: 'horizontal'
        }
        this.titleRef = React.createRef();
    };

    getContent = () => {
        const { id, name, title, isRequired, placeHolder, errorMessage, notice, validations, value, displaytype } = this.state;
        return {
            id,
            name,
            title,
            isRequired,
            placeHolder,
            errorMessage,
            notice,
            validations,
            value,
            type: this.props.type,
            displaytype: displaytype
        };
    };

    onClickEditTitle = () => {
        this.setState({
            editTitle: true
        });
        setTimeout(() => {
            this.titleRef.current.focus();
        });
    };

    handleStateChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
        this.setProperties({ [name]: value });
    };

    onFocusOutTitle = () => {
        this.setState({
            editTitle: false
        });
    };

    toggleIsRequired = (e) => {
        e.preventDefault();
        this.setState({
            isRequired: !this.state.isRequired
        });
        this.setProperties({ isRequired: !this.state.isRequired });
    };

    setProperties = (sendData) => {
        const { title, isRequired, placeHolder, name, notice, id, errorMessage, validations, value, displaytype } = this.state;
        const { type } = this.props;
        const properties = {
            type,
            title: title,
            id: id,
            name: name,
            notice: notice,
            isRequired: isRequired,
            errorMessage: errorMessage,
            placeHolder: placeHolder,
            validations: validations,
            value: value,
            displaytype: displaytype,
            ...sendData
        };
        this.props.setPropertiesData(properties, this.props.location);
        this.setIsActive(true);
    }

    changeProperties = (formContent) => {
        const { title, placeHolder, name, notice, id, errorMessage, isRequired, validations, value, displaytype } = formContent;
        this.setState({
            title: title,
            placeHolder: placeHolder,
            name: name,
            id: id,
            notice: notice,
            value: value,
            errorMessage: errorMessage,
            isRequired: isRequired,
            validations: validations,
            displaytype: displaytype,
        });
        this.props.setPropertiesData(formContent, this.props.location);
    };

    onClickDelete = () => {
        this.props.onClickDelete(this.props.location);
    };

    setIsActive = (isActive) => {
        this.setState({
            isActive
        });
    };

    render() {
        const { title, editTitle, isRequired, placeHolder, notice, errorMessage, isActive, value, displaytype } = this.state;
        return (
            <div className={displaytype == 'horizontal' ? "col-4 question-container-inner" : "col-12 question-container-inner"}>
                <div className={`pb-3 question-heading ${editTitle ? 'd-none' : 'd-block'}`}>
                    <strong className="d-inline-block">
                        {title}
                    </strong>
                    <div className="float-right">
                        <button onClick={this.onClickEditTitle} className="btn px-1 py-0">
                            <i className="fal fa-edit"></i>
                        </button>
                        <button onClick={() => this.setProperties({})} className="btn px-1 py-0">
                            <i class="fal fa-building"></i>
                        </button>
                    </div>
                </div>
                <div className={`pb-3 question-heading ${editTitle ? 'd-block' : 'd-none'}`}>
                    <input type="text" value={title} name="title" onChange={this.handleStateChange} onBlur={this.onFocusOutTitle} ref={this.titleRef} />
                </div>
                <div className="form-group">
                    <input type="text" value={value} name="value" className="form-control" onChange={this.handleStateChange} placeHolder={placeHolder} />
                </div>
            </div>
        );
    }
}